module.exports = __webpack_public_path__ + "img/h5_5-4.2130cc09.png";